import { createFileRoute } from "@tanstack/react-router";

import { AuthGate } from "@/components/AuthGate";
import { SharedWithMeView } from "@/components/SharedWithMeView";

export const Route = createFileRoute("/shared-with-me")({
  component: function SharedWithMePage() {
    return (
      <AuthGate>
        <SharedWithMeView />
      </AuthGate>
    );
  },
});
